import React from 'react'
import styled from 'styled-components'
import { MdCheck, MdSupportAgent } from 'react-icons/md'
import mimImg from '../../Asset/img/mim.jpg'
import minImg from '../../Asset/img/min.jpg'
const About = () => {
  return (
    <AboutWrapper>
      <AboutImgBox>
       <div className="nxImg">
        <span className='overlay'></span>
         <img src={mimImg} alt="" /> 
        </div>
        <div className="imgWrap">
            <span className='overlay'></span>
            <img src={minImg} alt="" />
        </div>
      </AboutImgBox>
      <AboutText>
        <span>|| About Company</span>
        <h1>We deal with the aspect of professional <span>IT Services</span></h1>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus maiores iste rerum cum praesentium reprehenderit delectus libero alias. Repellendus, totam.</p>
        <div className="box-con">
            <div className="box">
              <MdCheck className='box-ico' />
              <div className="text">
                <h3>User Experience</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias cumque odio, dicta sint quas ab illo velit rerum quo quod.</p>
              </div>  
            </div>
            <div className="box">
              <MdSupportAgent className='box-ico' />
              <div className="text">
                <h3>Quick Support</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias cumque odio, dicta sint quas ab illo velit rerum quo quod.</p>
              </div>  
            </div>
        </div>
      </AboutText>  
    </AboutWrapper>
  )
}

const AboutWrapper = styled.section`
 padding: 100px 20px;
 min-height: 100vh;
 background: #fff;
 display: grid;
 grid-template-columns: repeat(2, 1fr);
 gap: 1.5rem;
 @media screen and (max-width: 884px) {
   min-height: 75vh;
 }
 @media screen and (max-width: 768px) {
   grid-template-columns: 1fr;
   margin-top: 3rem;
 }
 @media screen and (max-width: 430px) {
   grid-template-columns: 1fr;
 }
 @media screen and (max-width: 360px) {
   margin-top: 0;
 }
`

const AboutImgBox = styled.article`
    position: relative;
    height: 100%;

    .imgWrap{
        width: 60%;
        position: absolute;
        top: 3.5rem;
        right: 1rem;
        border: 5px solid var(--main-color);
        transition: all 2s ease-in-out;
        img{
            width: 100%;
            height: 100%;
            border-radius: .2rem;
        }
        .overlay{
            background: rgba(255, 0, 0, 0.114);
            width: 100%;
            height: 100%;
            position: absolute;
        }

        &:hover{
            transform: translateX(-11rem);
            width: 60%;
            border: 5px solid #fff;
            filter: brightness(80%);
        }
    }

    .nxImg{
        position: absolute;
        top: 8px;
        left: 1rem;
        width: 75%;
        img{
            width: 100%;
            border-radius: .2rem;
        }
        .overlay{
            background: rgba(255, 0, 0, 0.082);
            width: 100%;
            height: 100%;
            position: absolute;
        }
    }

    @media screen and (max-width: 884px) {
      transform: translateY(10rem);
      .nxImg{
        width: 100%;
        left: 0;
      }
      .imgWrap{
        top: -8rem;
        left: 4rem;
        width: 70%;
        &:hover{
          transform: translateY(6rem);
          width: 100%;
          left: 0;
          filter: brightness(1);
        }
      }
    }

    @media screen and (max-width: 768px) {
    .imgWrap{
      display: none;
    }
    .nxImg{
      position: relative;
      left: 0;
      width: 100%;
      margin-bottom: 12rem;
    }
  }
  @media screen and (max-width: 430px) {
    transform: translateY(6rem);
    .imgWrap{
      display: none;
    }
    .nxImg{
      position: relative;
      left: 0;
      width: 100%;
    }
  }
`

const AboutText = styled.article`
 span{
    color: var(--bg-color);
    font-weight: 700;
 }
 h1{
    color: var(--text-color);
    font-size: 2.3rem;
    font-weight: 700;
    padding: 15px 0;
    text-transform: capitalize;
 }
 p{
     color: var(--text-color);
     font-size: 1.06rem;
     font-weight: 600;
     line-height: 1.7;
     max-width: 560px;
 }

 .box-con{
    padding: 15px 0;
    .box{
        display: flex;
        align-items: center;
        gap: 2rem;
        margin: 15px 0;

        .box-ico{
            background: var(--bg-color);
            border-radius: 50px;
            color: var(--main-color);
            width: 50px;
            height: 50px;
            padding: 8px;
        }

        .text{
            h3{
                color: var(--bg-color);
                padding: 8px 0;
            }
        }
    }
 }

 @media screen and (max-width: 884px) {
     h1{
      font-size: 1.9rem;
     }
    .box-con{
      .box{
        .box-ico{
          display: flex;
          aspect-ratio: 1/1;
          width: 80px;
          padding: 8px;
        }
      }
    }
  }

 @media screen and (max-width: 768px) {
    h1{
      font-size: 3rem;
    }
    .box-con{
      .box{
        .box-ico{
          display: flex;
          aspect-ratio: 1/1;
          width: 60px;
          height: 60px;
          padding: 8px;
        }
      }
    }
  }

  @media screen and (max-width: 430px) {
    h1{
      font-size: 1.8rem;
    }
    p{
      font-size: 15px;
    }
    .box-con{
      .box{
        .box-ico{
          display: flex;
          aspect-ratio: 1/1;
          width: 80px;
          height: 50px;
          padding: 8px;
        }
      }
    }
  }

  @media screen and (max-width: 360px) {
   .box-con{
    .box{
      .box-ico{
        width: 75px;
        height: 40px;
      }
    }
   }
  }

`

export default About